import { Image } from "@heroui/image";

import { ApplyForJob, FindTalent } from "@/components";
import { Img36 } from "@/public/assets";

const RecruitingWhyChooseCotton = () => {
  return (
    <section className="max-w-screen-2xl mx-auto lg:px-28 px-4 sm:px-6 py-12 sm:py-14 md:py-16">
      <div className="p-5 sm:p-6 md:p-8 bg-primary-50 dark:bg-primary-50 rounded-[24px] sm:rounded-[28px] md:rounded-[32px] gap-8 sm:gap-10 md:gap-12 grid grid-cols-1 md:grid-cols-2 items-center">
        {/* Text Section */}
        <div className="text-center md:text-left">
          <div
            className="mb-3 sm:mb-4 text-sm sm:text-base italic font-medium leading-5 sm:leading-6 tracking-[-0.176px] text-primary-950 dark:text-primary-900"
            data-aos="fade-up"
          >
            Why choose Cotton?
          </div>

          <div
            className="text-[24px] sm:text-[28px] md:text-[32px] text-primary-950 dark:text-primary-900 font-medium tracking-[-0.16px] mb-8 sm:mb-12 md:mb-16"
            data-aos="fade-up"
          >
            Our process is based on{" "}
            <span className="text-primary-600 dark:text-primary italic">
              research
            </span>{" "}
            and driven by{" "}
            <span className="text-primary-600 dark:text-primary italic">
              insight
            </span>
          </div>

          <div
            className="text-sm sm:text-base font-normal leading-5 sm:leading-6 tracking-[-0.176px] text-primary-950 dark:text-primary-900 mb-6"
            data-aos="fade-up"
          >
            We take the time to understand what’s really happening in your
            business and the labor market, then turn those insights into
            practical hiring decisions that set you up for long-term success.
          </div>

          <div
            className="flex flex-col sm:flex-row items-center gap-3 justify-center md:justify-start"
            data-aos="fade-up"
          >
            <FindTalent fullWidth={false} />
            <ApplyForJob
              className="border-0 text-primary-600 dark:text-primary"
              fullWidth={false}
            />
          </div>
        </div>

        {/* Image Section */}
        <div className="w-full" data-aos="fade-left">
          <Image
            className="w-full h-auto object-cover rounded-[20px] sm:rounded-[24px] md:rounded-[0px]"
            src={Img36.src}
          />
        </div>
      </div>
    </section>
  );
};

export default RecruitingWhyChooseCotton;
